<template>
  <div>
    <b-card class="accountDetailsCard">
      <template slot="header">
        <b-card-title>
          <strong>{{title}}</strong>
          <p-button type="success" round size="sm" style="float:right;" @click.native="editAccountDetails">Edit</p-button>
        </b-card-title>
        <p class="card-category my-4">{{subTitle}}</p>
      </template>
      <template slot="default" v-if="isAuthenticated">
        <b-row>
          <b-col>
            <b-form-row>
              <b-col>
                <b-form-group label="Company Name">
                  <p class="form-control">{{userAccountDetails.company}}</p>
                </b-form-group>
              </b-col>
            </b-form-row>
            <b-form-row>
              <b-col>
                <b-form-group label="Phone Number">
                  <p class="form-control">{{userAccountDetails.phone}}</p>
                </b-form-group>
              </b-col>
            </b-form-row>
            <b-form-row>
              <b-col>
                <b-form-group label="Logo Image" description="Size limited to 200 x 100 pixels">
                  <div class="company-logo" :style="companyLogoStyle()" />
                </b-form-group>
              </b-col>
            </b-form-row>
          </b-col>
          <b-col>
            <b-form-row>
              <b-col>
                <b-form-group label="Address">
                  <p class="form-control">{{userAccountDetails.address.street}}</p>
                </b-form-group>
              </b-col>
            </b-form-row>
            <b-form-row>
              <b-col>
                <b-form-group label="Address Line 2">
                  <p class="form-control">{{userAccountDetails.address.street2}}</p>
                </b-form-group>
              </b-col>
            </b-form-row>
            <b-form-row>
              <b-col>
                <b-form-group label="City">
                  <p class="form-control">{{userAccountDetails.address.city}}</p>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group label="State">
                  <p class="form-control">{{userAccountDetails.address.state}}</p>
                </b-form-group>
              </b-col>
            </b-form-row>
            <b-form-row>
              <b-col>
                <b-form-group label="Zip Code">
                  <p class="form-control">{{userAccountDetails.address.zip}}</p>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group label="Country">
                  <p class="form-control">{{userAccountDetails.address.country}}</p>
                </b-form-group>
              </b-col>
            </b-form-row>
          </b-col>
        </b-row>
      </template>
      <b-loading :loading="loading || !isAuthenticated" />
    </b-card>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

import ModalBus from '@/buses/modal'

export default {
  data() {
    return {
      title: "Account Details",
      subTitle: "Ensure that this information is as accurate as possible so that it properly reflected on any generated receipts.",
      processing: false,
    }
  },
  computed: {
    ...mapGetters([
      'user',
      'loading',
      'isAuthenticated',
      'userAccountDetails'
    ]),
  },
  methods: {
    editAccountDetails() {
      ModalBus.$emit('accountDetailsModal.open', this.userAccountDetails)
    },
    companyLogoStyle() {
      const {logo} = this.userAccountDetails
      if (logo) {
        return {
          background: `url(${logo}) no-repeat center center`
        }
      }
      return {}
    }
  }
}
</script>
<style lang="scss">
.accountDetailsCard {
  .form-control {
    border: solid 1px #ccc;
    line-height: 26px;
  }
  .company-logo {
    position: relative;
    box-sizing: content-box;
    border: solid 1px #ccc;
    height: 0;
    padding-top: 50%;
    &:before {
      content: '';
      position: absolute;
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
      // background: #0e0e0e;
    }
  }
}
</style>
